const whiteList = [
    '/login',
    '/test',
    '/register',
    '/sys/users/modifyPwd',
    '/error/401',
    '/error/404',
    '/error/500',
];

export default whiteList;